import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { AuthShell, Field } from "./Login";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      navigate("/login");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Invalid or expired token");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthShell title="New password." subtitle="Make it a good one.">
      <form onSubmit={handleSubmit} className="space-y-5" data-testid="reset-form">
        <Field label="New password (8+ characters)">
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={8}
            autoComplete="new-password"
            data-testid="reset-password"
            className="w-full bg-transparent border-b border-[var(--line)] focus:border-[var(--brand)] outline-none py-2 text-base"
          />
        </Field>
        {error && <p className="text-sm text-[var(--err)]" data-testid="reset-error">{error}</p>}
        <button type="submit" disabled={submitting || !token} className="btn-brand w-full disabled:opacity-60" data-testid="reset-submit">
          {submitting ? "Saving…" : "Reset password"}
        </button>
        <div className="text-center text-sm">
          <Link to="/login" className="text-[var(--ink-secondary)] hover:text-[var(--ink-primary)]" data-testid="reset-login-link">
            Back to sign in
          </Link>
        </div>
      </form>
    </AuthShell>
  );
}
